
export class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLDetailsElement | null} */
    this.details = this.querySelector('details');
    /** @type {HTMLElement | null} */
    this.summary = this.querySelector('summary');
    /** @type {HTMLElement | null} */
    this.contentWrapper = this.querySelector('.faq-item__content-wrapper');
    
    /** @type {Animation | null} */
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!this.details || !this.summary || !this.contentWrapper) return;

    // Use pointerdown to respond faster than click on mobile
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  /** @param {Event} e */
  onClick(e) {
    if (!this.details) return;
    
    e.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    if (!this.details || !this.summary) return;

    this.isClosing = true;

    // Store the height to animate from
    const startHeight = `${this.details.offsetHeight}px`;
    // Height to animate to (just the summary height)
    const endHeight = `${this.summary.offsetHeight}px`;

    // If an animation is already running, cancel it
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 350,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => { this.isClosing = false; };
  }

  open() {
    if (!this.details || !this.summary || !this.contentWrapper) return;

    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;

    window.requestAnimationFrame(() => {
      // Re-check references since this is an async callback
      if (!this.details || !this.summary || !this.contentWrapper) return;

      this.isExpanding = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.contentWrapper.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 350,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
      });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => { this.isExpanding = false; };
    });
  }

  /** @param {boolean} open */
  onAnimationFinish(open) {
    if (!this.details) return;
    
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = '';
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
